<template>
  <div class="footer">
    <div class="placeholder"></div>
    <span class="text" v-if="$store.state.encodeInfo.zhangtao === '车质汇'">深圳市车质汇汽车配件有限公司</span>
    <span class="text" v-else-if="$store.state.encodeInfo.zhangtao === '硬速'">硬速科技（深圳）有限公司</span>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.footer {
  position: relative;
  width: 100%;
  height: 40px;
  text-align: center;
  color: #888;

  .text {
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 100%;
    line-height: 20px;
    text-align: center;
    font-size: 12px;
  }
}
</style>
